import { Text } from '@thefarmersfront/kitchen-mobile';
import clsx from 'clsx';

import styles from './PolicyTable.module.scss';

type TypePolicyTableProps = {
  tableClassName?: string;
  tableTitle?: string;
  tableContents: {
    header: {
      children: React.ReactNode;
      colSpan?: number;
    }[];
    body: {
      children: React.ReactNode;
      colSpan?: number;
    }[];
  };
};

export const PolicyTable = ({ tableClassName, tableTitle, tableContents }: TypePolicyTableProps) => {
  return (
    <div>
      {tableTitle && (
        <Text size="xlarge" weight="semi-bold">
          {tableTitle}
        </Text>
      )}
      <table className={clsx(styles['policy-table'], tableClassName)}>
        <thead>
          <tr>
            {tableContents.header.map((header, index) => (
              <TableHead key={`${String(header.children)}-${index}`} colSpan={header.colSpan}>
                {header.children}
              </TableHead>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {tableContents.body.map((body, index) => (
              <TableCell key={`${String(body.children)}-${index}`} colSpan={body.colSpan}>
                {body.children}
              </TableCell>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const TableHead = ({ children, colSpan }: { children: React.ReactNode; colSpan?: number }) => {
  return (
    <th colSpan={colSpan}>
      <Text size="xlarge" weight="semi-bold">
        {children}
      </Text>
    </th>
  );
};

const TableCell = ({ children, colSpan }: { children: React.ReactNode; colSpan?: number }) => {
  return (
    <td colSpan={colSpan}>
      <Text size="small" color="secondary">
        {children}
      </Text>
    </td>
  );
};

export default PolicyTable;
